import { observable, action, } from 'mobx';
import _ from 'lodash';


export default class DigitalSportsTechIntegrationStore {

  @observable betBuilderRespone = [];
  
  @action updateBetBuilderReponse(reponse) {
    this.betBuilderRespone = reponse;
  }
}



// WEBPACK FOOTER //
// ./src/app/stores/DigitalSportsTechIntegrationStore.js